module.exports = __webpack_public_path__ + "static/media/apple-logo-white.760f9dfe.png";